exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* ANIMATION */\n/* SHADOWS */\n.OrderStateLoader__loader__2ytnj {\n  margin: 10px 0 -11px 0; }\n  .OrderStateLoader__loader__2ytnj svg path,\n  .OrderStateLoader__loader__2ytnj svg rect {\n    fill: #0070DD; }\n", ""]);

// exports
exports.locals = {
	"loader": "OrderStateLoader__loader__2ytnj"
};